import { CodedError } from '../CodedError';
import { errorCodeTypes } from './errorCodeTypes';

export class GetAllReminderRuleError extends CodedError {
  static get errorName() {
    return errorCodeTypes.getAllReminderRuleError.code;
  }

  constructor(message = errorCodeTypes.getAllReminderRuleError.message) {
    super(message);
    this.code = errorCodeTypes.getAllReminderRuleError.code;
    this.name = errorCodeTypes.getAllReminderRuleError.name;
  }
}
